import { render, staticRenderFns } from "./ProjectScaffold.vue?vue&type=template&id=a03ec80a&scoped=true&"
import script from "./ProjectScaffold.vue?vue&type=script&lang=js&"
export * from "./ProjectScaffold.vue?vue&type=script&lang=js&"
import style0 from "./ProjectScaffold.vue?vue&type=style&index=0&id=a03ec80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ec80a",
  null
  
)

export default component.exports